module.exports = __webpack_public_path__ + "static/media/地震後損失大比較！停水停電虧多少.74e01f89.png";